import React, {Component} from 'react';
import {Input} from 'reactstrap';
import './QuestionFieldCard.scss';
import Checkbox from "../../../shared/forms/Checkbox";

class QuestionFieldCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      answers: [''],
      question: '',
      subtitle: '',
      dropdown: true
    };
  }

  componentDidMount() {
    if(this.props.initialValues) {
      this.setState({
        dropdown: this.props.initialValues.dropdown
      })
    }
  }

  get initialValues() {
    return this.props.initialValues && this.props.initialValues.fields ? this.props.initialValues.fields : [];
  }

  get answers() {
    if (this.initialValues && this.initialValues.answers && this.initialValues.answers.length > 0) {
      return this.initialValues.answers;
    }

    return this.state.answers;
  }

  get question() {
    if (this.props.initialValues && this.props.initialValues.form_title && this.state.question === '') {
      return this.props.initialValues.form_title;
    }

    return this.state.question;
  }

  get subtitle() {
    if (this.props.initialValues && this.props.initialValues.fields && this.props.initialValues.fields.subtitle && this.state.subtitle === '') {
      return this.props.initialValues.fields.subtitle;
    }

    return this.state.subtitle;
  }

  addAnswerClick(){
    let answers = this.answers;
    answers.push('');

    this.setState({ answers });
  }

  handleAnswerChange(optionIndex, e) {
    const { value } = e.target;

    let answers = this.answers;
    answers[optionIndex] = value;

    this.setState({ answers });
  }

  handleQuestionChange(e) {
    this.setState({
      question: e.target.value
    });
  }

  handleSubtitleChange(e) {
    this.setState({
      subtitle: e.target.value
    });
  }

  handleFormTitleChange(e) {
    this.setState({
      formTitle: e.target.value
    });
  }

  removeAnswerClick(optionIndex){
    let answers = this.answers;
    answers.splice(optionIndex, 1)
    this.setState({ answers });
  }

  handleSubmit() {
    const fields = {
      answers: this.answers,
      subtitle: this.subtitle
    }

    this.props.onSave({
      fields,
      form_title: this.question,
      dropdown: this.state.dropdown
    });
  }

  render() {
    return (
      <div className="question-field">
        <div className="form-title">
          <div className="field-config-container">
            <div className="label-container">
              <label className="input-type">
                Title
              </label>
            </div>

            <div className="input-conatiner">
              <Input
                name="form-title"
                onChange={this.handleQuestionChange.bind(this)}
                placeholder="Title"
                type="text"
                value={this.question}
              />
            </div>
          </div>
        </div>

        <div className="form-title">
          <div className="field-config-container">
            <div className="label-container">
              <label className="input-type">
                Subtitle
              </label>
            </div>

            <div className="input-conatiner">
              <Input
                name="form-title"
                onChange={this.handleSubtitleChange.bind(this)}
                placeholder="Subtitle"
                type="text"
                value={this.subtitle}
              />
            </div>
          </div>
        </div>

        <div className="field-config-container">
            <div className="answers">
                <label className="input-type">
                    Add Answer
                </label>

                {this.answers.map((answer, j) => (
                <div key={`${j}`} className="answers-container">
                    <Input
                      name="value"
                      onChange={this.handleAnswerChange.bind(this, j)}
                      placeholder="Answer"
                      type="text"
                      value={answer}
                    />

                  <div className="delete-container">
                    <button className="button danger small" type="button"
                            onClick={this.removeAnswerClick.bind(this, j)}>
                      <i className="fa fa-trash"/>
                    </button>
                  </div>
                </div>
                ))
                }

                <button className="button primary small" onClick={() => this.addAnswerClick()}>
                    Add Answer
                </button>
            </div>
        </div>

        <div className="field-config-container">
          <Checkbox
            checked={!!this.state.dropdown} label="Dropdown view" name="dropdown" onChange={(e) => {
            this.setState({
              dropdown: true
            })
          }}
          />
          <br />
          <Checkbox
            checked={!this.state.dropdown} label="Checklist view" name="checklists" onChange={(e) => {
            this.setState({
              dropdown: false
            })
          }}
          />
        </div>

        <button className="button primary large log-field-save" type="button" onClick={this.handleSubmit.bind(this)} >
          Save
        </button>
      </div>
    )
  }

}

export default QuestionFieldCard;
